module.exports = __webpack_public_path__ + "static/media/mg-white.33e02790.png";